export default __webpack_public_path__ + "static/project-start1-9021d99f87ec478ea7e93fa2ec811de8.png";